import React from 'react';
import $ from 'jquery';
import './index.less';
import ShowModal from '../showModal/index.jsx';
import { requests,messageShow,systemConfig,debounceOther,fromClassName } from '../../utils/http';
import { GetListingProductByCateIdRequest,SaveOrSavePuHuoSupplierRequest,VerificationCategoryV2Request,GetMatchingCategoryRequest,BatchListingMobileByProductIdListV2Request } from '../../utils/api';
import { Select,Input,MessageBox} from 'element-react';
import '../../assets/css/common.less'
import MyLoading from '../../components/showLoading/showLoading';
import ListingProductEdit from '../../components/listingProductEdit';
import SelectCategoryModule from '../../components/selectCategoryModule';
import SelectCategoryModuleV2 from '../../components/selectCategoryModuleV2';
import { withRouter } from 'react-router-dom';
class PreviewDistributionList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            delDailog: false,
            isShowDailog: props.showModal,
            productList: props.productList || [],
            delId:'',
            targetPlatformType:props.targetPlatformType,
            targetShopId:props.targetShopId,
            supplierProductDataList:[],

            isShowListingProductEditDailog: false,
            listingProductEditByProduct: null,//修改的商品id
        };
        
    }

    componentDidMount() {
        this.initSupplierProduct()
    }

    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        this.setState({
            isShowDailog: props.showModal,
            productList: props.productList,
            targetPlatformType:props.targetPlatformType,
            targetShopId:props.targetShopId,
        },()=>{
            console.log(this.props);
        })

    }

    async initSupplierProduct(){
        console.log(111);
        const supplierProductList = []
        var productList = this.state.productList;
        for (let i = 0; i < productList.length; i++) {
            supplierProductList.push({
                SupplierProductId: productList[i].ProductId,
                SourcePlatform: productList[i].SourcePlatform,
            })
        }
        const res = await this.verificationCategoryV2(supplierProductList);
        this.setState({ isLoading: false });
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        {
            this.cancel();
            return;
        }
        if (res.Success) {
            var listSupplierProduct = res.Data.SupplierProducts;
            if (listSupplierProduct == null || listSupplierProduct == undefined)
                listSupplierProduct = [];

            var faildList = [];
            var successList = [];

            supplierProductList.forEach(s => {
                var index = listSupplierProduct.findIndex(m => m.ProductId == s.SupplierProductId);
                if (index == -1) {
                    faildList.push(listSupplierProduct[index]);
                } else {
                    successList.push(listSupplierProduct[index])
                }
            })

            if (successList.length == 0) {
                messageShow("当前选择的货源，获取不到商品！", 'error');
                this.cancel();
                return;
            }

            if (successList.length > 0 && faildList.length > 0)
                messageShow("有" + faildList.length + "个商品获取不到，已过滤显示！", 'warning');
                var supplierProductDataList = successList.map(x => {
                    x.SubjectLength = this.getStrByteCnt(x.Subject)
                    return {
                        supplierProduct:x
                    }})
            this.setState({
                supplierProductDataList
            },()=>{
                this.getCategoryBySupplierOne();
            })
        } 
        else {
            if (res.ErrorCode == "SHOP_EXPIRED") {
                messageShow("选择的店铺包含授权过期，请选择重新店铺！", 'error');
            }
            else if (res.ErrorCode == "ReachListingCount") {
                MessageBox.confirm(<div>
                    <div>
                        根据1688货源分销规则，使用1688免费版【铺货代发】
                        授权货源最多只能铺货5次。订购1688【<a className='defColor' href='https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404' target={'_blank'}>铺货代发</a>】高级版授权，不限铺货次数。
                    </div>
                    <div style={{ "marginTop": "16px" }}>
                        特别说明:免费版、高级版指1688货源端【铺货代发】
                    </div>
                </div>, '提示', {
                    customClass: 'home_reach_listing_count_dailog',
                    confirmButtonText: "订购高级版"
                }).then(() => {
                    window.open('https://pc.1688.com/product/detail.htm?spm=a26370.isv_inner_8076003.0.0.5200YeNJYeNJRU&productCode=FLjfKOZUVVsdPaSNpobsgo5MSv%2BCKZ62omVo8x4qfKc%3D&productType=GROUP&mkey=k_12039404');
                });
            } 
            else if (res.ErrorCode == "NOT_FREIGHT_TEMPLATE") {
                this.setState({
                    isShowNotFreightTemplate: true,
                    notFreightTemplateValue: res.Message
                });
            } 
            else {
                if (res.Message.indexOf("商品信息获取失败") != -1)
                    messageShow("商品信息获取失败", 'warning');

                else
                    messageShow("铺货前匹配类目失败:" + res.Message, 'error');
            }
            // this.cancel();
        }


    }
    verificationCategoryV2(supplierProductList){
        
        if (this.state.selectPlatformNav == 'jxhy' && this.state.isShowWarn === true) {
            this.alibabaAuthDailog(this);
            return;
        }
        if(!supplierProductList){
            supplierProductList = []
            let productList = this.state.productList;
            for (let i = 0; i < productList.length; i++) {
                supplierProductList.push({
                    SupplierProductId: productList[i].ProductId,
                    SourcePlatform: productList[i].SourcePlatform,
                })
            }
        }

        if (supplierProductList.length == 0) {
            messageShow("请选择商品！", 'info');
            return;
        }
        const alibabaSupplierProducts = supplierProductList.filter(x => x.SourcePlatform == 'AlibabaZhuKe'
            || !x.SourcePlatform);
        const taoteSupplierProducts = supplierProductList.filter(x => x.SourcePlatform == 'TaoteZhuKe');
        if (alibabaSupplierProducts.length > 0 && !systemConfig.zhukeAlibabaAuth) {
            this.cancel()
            this.alibabaAuthDailog(this);
            return;
        }
        if (taoteSupplierProducts.length > 0 && !systemConfig.zhukeTaoteAuth) {
            this.cancel()
            this.taoteAuthExpireDailog(this);
            return;
        }

        const data = {
            TargetShopIds: [this.state.targetShopId],
            SupplierProductList: supplierProductList,
        }
        if (this.state.selectPlatformNav == 'jxhy')
            data.ProductTag = 'pifatuan';

        this.setState({ isLoading: true})
        return VerificationCategoryV2Request(data)
    }
    onChnageDebounceOther = (item,name,value)=>{
        item[name] = value;
        if(name == 'Subject'){
            const cnt = this.getStrByteCnt(value)
            item.SubjectLength = cnt;
        }
        this.setState({ })
    }
    async getCategoryBySupplierOne() {
        const productList = this.state.supplierProductDataList;
        
        const shopIdL = [this.state.targetShopId];
        const lunxunList = productList.map(x => {
            return {
                TargetShopIds: shopIdL,
                SourceProductId: x.supplierProduct.ProductId,
                SourcePlatform: x.supplierProduct.PlatformType,
                SourceCateId: x.supplierProduct.CategoryId,
                SourceCateName: x.supplierProduct.CategoryName,
                ProductTitle: x.supplierProduct.Subject,
            }
        })

        //任务发出去，按商品的维度
        for (var i = this.state.supplierProductDataList.length - 1; i >= 0; i--) {
            const item = this.state.supplierProductDataList[i]
            const data = {
                TargetShopIds: shopIdL,
                SourceProductId: item.supplierProduct.ProductId,
                SourcePlatform: item.supplierProduct.PlatformType,
                SourceCateId: item.supplierProduct.CategoryId,
                SourceCateName: item.supplierProduct.CategoryName,
                ProductTitle: item.supplierProduct.Subject,
                UseCustom: true,
            }
            this.getMatchingCategory(data,item)
        }
    }
    async getMatchingCategory(data,item){
        const res = await GetMatchingCategoryRequest(data);
        let resList = (res.Data && res.Data.MatchingShops) || [];
        if(resList.length > 0 && resList[0].TargetCates && resList[0].TargetCates.length > 0){
            item.catePathList = resList[0].TargetCates.map(x => { return { CateId : x.Id,CateName : x.Name }})
            this.setState({ })
        }
    }

    cancelModul = (typeName) => {
        this.setState({ [typeName]: false });
    }

    cancel = () => {
        this.setState({
            isShowDailog: false
        }, () => {
            if (typeof this.props.cancelDailog == "function") {
                this.props.cancelDailog();
            }
        })
    }

    sureBatch = () => {
        if(this.state.supplierProductDataList.length == 0){
            this.cancel()
            return;
        }
        var notMatchCateList = this.state.supplierProductDataList.filter(x => !x.catePathList || x.catePathList.length == 0);
        if(notMatchCateList.length > 0){
            notMatchCateList.forEach(x =>{
                x.isError = true
            })
            messageShow('请选择类目')
            return;
        }
        var titleLenErrorList = this.state.supplierProductDataList.filter(x => x.supplierProduct.SubjectLength > 60);
        if(titleLenErrorList.length > 0){
            messageShow('【'+titleLenErrorList[0].supplierProduct.Subject+'】：标题过长')
            return;
        }
        this.setState({
            isShowDailog: false
        }, () => {
            if (typeof this.props.sureBatchPuhuo == "function") {
                this.props.sureBatchPuhuo(this.state.supplierProductDataList);
            }
        })
    }
    getStrByteCnt(str) {
        if (!str) return 0;
        return str.replace(/[\u0391-\uFFE5]/g, "aa").length
    }

    delItem = (item) => {
        this.setState({ delDailog: true,delId:item.supplierProduct.ProductId })
    }
    sureDel=()=>{

        let delId=this.state.delId;
        let productList=this.state.supplierProductDataList;
        
        var itemIndex = productList.findIndex(x => x.supplierProduct.ProductId == delId)
        if(itemIndex > -1)
        {
            productList.splice(itemIndex,1)
        }

        this.setState({productList,delDailog:false})
    }
    getListingProductByCateId = async (listingProduct) => {
        var listingTask = this.state.listingProductEditByProduct;
        const data = { }
        data.TargetShopIds = this.state.targetShopId
        data.TargetPlatformType = this.state.targetPlatformType
        data.ListingProduct = listingProduct,
        data.RelationCode = listingProduct.RelationCode
        this.setState({isLoading : true})
        const res = await GetListingProductByCateIdRequest(data);
        this.setState({isLoading : false})
        if(res.Success && res.Data && res.Data.ProductEditDataList && res.Data.ProductEditDataList.length > 0){
          return res.Data.ProductEditDataList[0];
        }
        return null
    }
    clickQuickEdit(item,from){
        let product = { }

        product.targetShopId = this.state.targetShopId
        product.targetPlatformType = this.state.targetPlatformType
        product.supplierProductId = item.supplierProduct.ProductId
        product.sourcePlatform = item.supplierProduct.PlatformType
        product.relationCode = item.RelationCode
        product.catePathList = item.catePathList
        product.step = from
        product.title = item.supplierProduct.Subject
        this.setState({listingProductEditByProduct:product,isShowListingProductEditDailog:true})
    }
    closeListingProductEdit = () => {
        this.setState({ isShowListingProductEditDailog: false })
    }
    saveProductEdit = async (titles, catePropsList, salesPropList, skuList, isPh,catePath,model) =>{
        var listingTask = this.state.listingProductEditByProduct;
        var data = {
            Title: titles,
            SupplierProductCode: listingTask.supplierProductCode,
            SupplierProductId: listingTask.supplierProductId,
            CatePathList:catePath,
            SourcePlatform: listingTask.sourcePlatform,
            CateProps: catePropsList,
            SalesProps: salesPropList,
            Skus: skuList,
            ShopId: listingTask.targetShopId,
            PlatformType: listingTask.targetPlatformType,
            ListingTaskCode: listingTask.taskCode,
            IsPuHuo: isPh,
            Source: "铺货日志",
        }
        console.log(JSON.stringify(data))
        console.log(model);
    
        this.setState({ isLoading:true})
        const res = await SaveOrSavePuHuoSupplierRequest(data);
        this.setState({ isLoading: false });
        if(res.Success && res.Data){
            this.state.isShowListingProductEditDailog = false;
            const supplierProductInfo = this.state.supplierProductDataList.find(x => x.supplierProduct.ProductId ==  listingTask.supplierProductId);
                
            console.log('supplierProductInfo =>',supplierProductInfo);
            if(supplierProductInfo){
                supplierProductInfo.RelationCode = res.Data.RelationCode
                supplierProductInfo.catePathList = catePath
                supplierProductInfo.supplierProduct.Subject = titles
                console.log('supplierProductInfo =>',supplierProductInfo);
            }
            this.setState({ })
        }else{
            messageShow('保存失败: '+res.Message,'error')
        }
    }
    
    gotoDistributionSet = () => {
        this.props.history.push('/distributionSet');
    }
    showSelectCategoryModule = (item) => {
        item.showSelectCategoryModule = true
        this.setState({
           showSelectCategoryModule: true,
           selectCategoryItem: item,
        })
    }
    stopM = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      }
      
    hideShowSelectCategoryModule = () => {
        this.state.supplierProductDataList.forEach(x =>{
            x.showSelectCategoryModule = false;
        })
        this.setState({})
    }
    selectCategory = async (cateList, selecCatetTitle)=>{
        this.setState({showSelectCategoryModule : false})
        if (!cateList) return;
        let tempCatePathList = cateList.map(x => { return { CateId: x.Id, CateName: x.Name } });
        const selectItem = this.state.selectCategoryItem
        
        if(!selectItem)
            return;
        selectItem.showSelectCategoryModule = false;
        //如果类目选择的为相同类目则不更改相关内容
        if (selectItem.catePathList && selectItem.catePathList.length > 0 
            && cateList[cateList.length - 1].Id == selectItem.catePathList[selectItem.catePathList.length - 1].CateId)
            return;
        if(selectItem.RelationCode)
        {
            await MessageBox.confirm('修改类目可能会导致部分内容丢失，确认修改？',{
                title:'确定修改类目？'});
            selectItem.catePathList =tempCatePathList
        }
        else{
            selectItem.catePathList =tempCatePathList
        }
        this.setState({ supplierProductDataList:this.state.supplierProductDataList})
    }
    alibabaAuthDailog(that) {
        MessageBox.msgbox({
            title: '授权提示',
            message: <span>当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>1688货源授权</span>，您未获得1688授权或者授权失效，请先进行授权</span>,
            type: 'info',
            showCancelButton: false,
            confirmButtonText: '去授权'
        }).then((action) => {
            if (action == 'confirm') {
                const path = { pathname: '/myAuth', state: { from_action: "alibaba_auth_expire" } }
                that.props.history.push(path);
            }
        })
    }
    taoteAuthExpireDailog(that) {
        MessageBox.msgbox({
            title: '授权提示',
            message: <span>当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>淘特货源授权</span>，您未获得淘特授权或者授权失效，请先进行授权</span>,
            type: 'info',
            showCancelButton: false,
            confirmButtonText: '去授权'
        }).then((action) => {
            if (action == 'confirm') {
                const path = { pathname: '/myAuth', state: { from_action: "taote_auth_expire" } }
                that.props.history.push(path);
            }
        })
    }

    render() {


        let elems = this.state.isShowDailog ?
            <div className='previewDistributionListWrap' onClick={()=>{ this.hideShowSelectCategoryModule()}}>
                <div className="previewDistributionListWrap-main">
                    <div className="previewDistributionListWrap-title">
                        <span>预览铺货商品列表</span>
                        <i className='iconfont icon-jia-copy1' onClick={() => this.cancel()}></i>
                    </div>
                    <div className="previewDistributionListWrap-table">
                        <table className="stockup_table_content">
                            <thead>
                                <tr>
                                    <th style={{ minWidth: "80px", textAlign: "center" }}>图片</th>
                                    <th style={{ minWidth: "250px" }}>商品明细</th>
                                    <th style={{ minWidth: "100px", textAlign: 'center' }}>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.supplierProductDataList.map((item, index) =>

                                        <tr key={item.supplierProduct.ProductId}>
                                            <td style={{ textAlign: "center" }}>
                                                <div className="productShow table-product">
                                                    <div className="productShow-imgWrap">
                                                        <img src={item.supplierProduct.PicURI}  />
                                                        {
                                                            item.supplierProduct.PlatformType == 'TaoteZhuKe' ?
                                                            <span className="product-status" style={{ backgroundColor: '#f7941f' }}>淘特</span>:
                                                            <span className="product-status" style={{ backgroundColor: '#f7941f' }}>1688</span>
                                                        }
                                                        
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='previewDistributionListWrap-formWrap'>
                                                    <label>
                                                        <span className='previewDistributionListWrap-formWrap-title'>标题</span>
                                                        <div className="titeInputWrap">
                                                            <input id="productName"  className={fromClassName({
                                                                titleError:item.supplierProduct.SubjectLength > 60
                                                            })} type="text" style={{ width: "420px" }} value={item.supplierProduct.Subject} key={item.supplierProduct.ProductId}
                                                                onChange={(e)=>{ this.onChnageDebounceOther(item.supplierProduct,'Subject',e.target.value)}}/>
                                                            <div className="titeInputWrap-rightWrap"><span>{item.supplierProduct.SubjectLength}</span><i>/</i><span>60</span></div>
                                                        </div>
                                                    </label>
                                                    <label>
                                                        <span className='previewDistributionListWrap-formWrap-title'>售卖价（￥）</span>
                                                        <div className="previewDistributionListWrap-formWrap-text">
                                                            <span>
                                                                {/* {item.MinPrice}~{item.MaxPrice} */}
                                                                (源:{item.supplierProduct.MinPrice}~{item.supplierProduct.MaxPrice})
                                                            </span>
                                                        </div>
                                                        <span className='iconfont icon-bianji' onClick={()=>{ this.clickQuickEdit(item,'editPrice') }}></span>
                                                    </label>
                                                    <label>
                                                        <span className='previewDistributionListWrap-formWrap-title'>类目</span>
                                                        <div className="titeInputWrap" onClick={(e)=>this.stopM(e)} style={{width:'440px'}}>
                                                            <div className={fromClassName({
                                                                    'categoryChoose':true,
                                                                 })} 
                                                                onClick={() => this.showSelectCategoryModule(item)}>
                                                            {
                                                                item.catePathList && item.catePathList.length > 0 ?
                                                                <span>{item.catePathList.map(x => x.CateName).join("-")}</span>
                                                                : <span>请选择商品类目</span>
                                                            }
                                                            <i className="iconfont icon-xiangxia"></i>
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                                <div>
                                                    <span className='warnColor'>来源类目:{item.supplierProduct.CategoryName}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='opearteBtns'>
                                                    <span className='defColor hover' onClick={()=>{ this.clickQuickEdit(item) }}>快速编辑</span>
                                                    <span className='dangerColor hover' onClick={() => this.delItem(item)}>删除商品</span>
                                                </div>
                                            </td>
                                        </tr>

                                    )
                                }


                                
                            </tbody>
                        </table>
                    </div>
                    <div className="previewDistributionListWra-footer">
                        <span onClick={() => this.cancel()} class="el-button" style={{ backgroundColor: '#fff', color: '#5584ff', border: '1px solid #5584ff' }}>上一步</span>
                        <span onClick={() => this.sureBatch()} class="el-button el-button--primary">批量铺货</span>
                    </div>


                </div>
                <ShowModal showModal={this.state.delDailog} width="500px" hideBtn={true} cancelDailog={() => this.cancelModul("delDailog")} >
                    <div className="showModalWrap-box-commonContent" style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <div className="showModalWrap-commonContent-item" style={{ width: "unset" }}>
                            <i className="iconfont icon-wenhao icofontStatus"></i>
                        </div>
                        <div style={{ fontSize: '16px', color: "#888" }}>您确定删除吗？</div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span className="showModalWrap-box-footer-btn" onClick={()=>this.sureDel()}>确定</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={()=>{ this.cancelModul("delDailog")}}>取消</span>
                    </div>
                </ShowModal>
                {
                    this.state.isShowListingProductEditDailog == true ?
                        <ListingProductEdit cancelDailog={this.closeListingProductEdit} showModal={this.state.isShowListingProductEditDailog} products={this.state.listingProductEditByProduct} saveProductEdit={this.saveProductEdit} saveAndPuhuoProductEdit={this.saveAndPuhuoProductEdit} changeCate={this.getListingProductByCateId} /> : null
                }
                <ShowModal top={100} wrapSkin="showSelectCategoryModule" zIndex={10000} showModal={this.state.showSelectCategoryModule} titleName={"选择类目"} cancelDailog={() => this.cancelModul("showSelectCategoryModule")} hideBtn={true} showLeftTopBtn={true}>
                    <SelectCategoryModule
                        showSelectCategoryModule={this.state.showSelectCategoryModule}
                        targetPlatformType={this.state.targetPlatformType}
                        targetShopId={this.state.targetShopId}
                        selectCategory={this.selectCategory}
                    />
                </ShowModal>
                {/* 未设置运费模板 */}
                <ShowModal width={"500px"} showModal={this.state.isShowNotFreightTemplate} hideBtn={true} titleName="提示" >
                    <div className="showModalWrap-box-commonContent" style={{ fontSize: "16px", padding: "20px" }}>
                        <div>
                            <span>{this.state.notFreightTemplateValue}</span>
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span className="showModalWrap-box-footer-btn" onClick={() => this.gotoDistributionSet()}>前往设置</span>
                        <span className="showModalWrap-box-footer-btn cancleBtn" onClick={() => this.cancelModul("isShowNotFreightTemplate")}>取消</span>
                    </div>
                </ShowModal>
                <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />
            </div> : null
        return (elems);
    }
}

export default withRouter(PreviewDistributionList);



// WEBPACK FOOTER //
// ./src/components/previewDistributionList/index.jsx